/*
 * Project: bellcloud
 * File: packages/types/device/mini/information.ts
 * Author: SWAN
 * Created: 2025-01-27
 * Description: Mini device information parsing functions
 */

import { MiniSensorType, getMiniSensorTypeInfo } from './sensors';

/**
 * Equipped Sensor를 센서 타입 이름으로 변환
 * @param equippedSensor equipped_sensor 값 (number)
 * @returns 센서 타입 라벨
 */
export function parseEquippedSensor(equippedSensor: number | undefined | null): string {
  if (equippedSensor === undefined || equippedSensor === null) {
    return 'Unknown';
  }

  const sensorType = equippedSensor as MiniSensorType;
  const info = getMiniSensorTypeInfo(sensorType);
  return info.label || 'Unknown';
}
